module.exports = __webpack_public_path__ + "static/media/artificialintelligence.35b8dac5.png";